'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtAddress', [
	'$i18next',
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtAddress: '@',
				diffObject: '=',
				disableHeader: '@'
			},
			link: function (scope, element, attrs) {
				scope.showHeader = true;
				attrs.$observe('pmtAddress', function (newVal) {
					scope.address = scope.$eval(newVal);
				});
				attrs.$observe('disableHeader', function (newVal) {
					scope.showHeader = !scope.$eval(newVal);
				});
			},
			templateUrl: 'shared/dataPrinters/pmtAddressView.html'
		};
	}
]);
